import { Popper as MuiPopper, PopperPlacementType } from '@mui/material'
import { VirtualElement } from '@popperjs/core'

import React, { ReactNode } from 'react'

type Props = {
  open: boolean
  anchorEl: null | VirtualElement | HTMLElement | (() => HTMLElement) | (() => VirtualElement);
  children: ReactNode
  placement?: PopperPlacementType
  className?: string
}

const Popper = ({ anchorEl, open, children, placement = 'bottom-start', className } : Props) => {
  return (
    <MuiPopper
      className={className}
      anchorEl={anchorEl}
      open={open}
      placement={placement}
    >
      {children}
    </MuiPopper>
  )
}

export default Popper
